<div class="container">
    <div class="row justify-content-center">
        <iframe
            [src]="'pages.page-url-5' | translateSafeUrl"
            width="100%"
            style="height: 80vh"
        ></iframe>
    </div>
</div>
